import classNames from "classnames";
import React from "react";
import { observer } from "mobx-react";
import { CSSTransition } from "react-transition-group";
import { AnimationDuration } from "../../../styles/Animations";
import { Tick, IconSize } from "../../icons";

interface ICheckboxProps {
  item: {
    id: string;
    value: string;
    label?: string;
  };
  // If you have multiple checkbox components, but want to use a single handling `handleOnClick` it can be difficult to
  // know which checkbox was triggered. The `toggleKey` parameter is used to externally identify what component is\
  // calling the `handleOnClick`
  toggleKey?: string;
  isSelected: boolean;
  isDisabled?: boolean;
  /**
   * Use the large variant of the checkbox. This is a blue variant, most notably used in the Dashboard.
   */
  isLarge?: boolean;
  // If toggleKey is not provided we just send through an empty string for the toggleKey
  handleOnClick: (toggleKey: string, event: React.MouseEvent<HTMLDivElement>) => void;
}

@observer
export default class Checkbox extends React.Component<ICheckboxProps> {
  public static defaultProps: Partial<ICheckboxProps> = {
    isDisabled: false,
  };

  public render() {
    const { item, isSelected, isDisabled, isLarge } = this.props;

    const checkBoxClickFieldClasses = classNames({
      "checkbox-component__click-field": true,
      "checkbox-component__click-field--without-label": !item.label,
      "checkbox-component__click-field--is-disabled": isDisabled,
    });

    const checkboxBoxClasses = classNames({
      "checkbox-component__box": true,
      "checkbox-component__box--is-selected": isSelected,
      "checkbox-component__box--is-disabled": isDisabled,
      "checkbox-component__box--large": isLarge,
    });

    return (
      <div className={`checkbox-component checkbox-${item.id}`}>
        <div className={checkBoxClickFieldClasses} onClick={this.handleOnClick}>
          <div className={checkboxBoxClasses} id={item.id}>
            <CSSTransition
              mountOnEnter
              unmountOnExit
              in={isSelected}
              timeout={AnimationDuration.Medium}
              classNames="checkbox-component__box-actions-"
            >
              <Tick size={IconSize.Small} className="checkbox-component__tick" />
            </CSSTransition>
          </div>
          {!!item.label && this.renderLabel()}
        </div>
      </div>
    );
  }

  private renderLabel = () => {
    const { item, isDisabled } = this.props;
    const checkboxLabelClasses = classNames("checkbox-component__label", {
      "checkbox-component__label--is-disabled": isDisabled,
    });

    return (
      <label htmlFor={`checkbox-${item.id}`} className={checkboxLabelClasses}>
        {item.label}
      </label>
    );
  };

  private handleOnClick = (event: React.MouseEvent<HTMLDivElement>) => {
    this.props.handleOnClick(this.props.toggleKey || "", event);
  };
}
